import { FronteggContext } from '@frontegg/rest-api';
import {
  createOverridesConfig,
  deletePromptOverridesConfig,
  editOverridesConfig,
  getAllConditionsOverrideConfig,
  getAllPromptScreenOverrideConfig,
  getFilterPromptOverrideConfig,
  getOverridesByIdConfig,
} from '../lib/promptoverrides.url';
import { showToastError } from 'src/utilities/errortoast';
import {
  getAllConditionsOverrideSlice,
  getAllOverridesListSlice,
  getAllPromptScreenOverrideSlice,
  getPromptOverridesByIdSlice,
} from '../slices/promptoverrides.slice';
import { Axios } from 'src/lib';
import { superAdminLoadingSlice } from '../slices/condition.slice';
import { showToastSuccess } from 'src/utilities/toast';

export const addPromptOverrideAction = (
  payload,
  setIsOpen,
  setLlmVersionSelected,
  setDescription,
  setIsOrganizationSelected,
  selectedOrganizationUUID,
  selectedCondition,
  setIsPromptScreenSelected
) => {
  return async (dispatch) => {
    dispatch(superAdminLoadingSlice(true));
    try {
      const { url } = createOverridesConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': `${selectedOrganizationUUID}`,
        'Headless-Mode': true,
      };
      const result = await Axios.post(url, payload, { headers });
      if (result?.status === 201) {
        showToastSuccess('Prompt overrides created successfully');
        setIsOpen(false);
        dispatch(
          getFilterPromptOverride(selectedOrganizationUUID, selectedCondition)
        );
        setLlmVersionSelected && setLlmVersionSelected(false);
        setDescription && setDescription(null);
        setIsOrganizationSelected(false);
        setIsPromptScreenSelected && setIsPromptScreenSelected(false);
      }
    } catch (e) {
      showToastError('Error occurred');
      dispatch(superAdminLoadingSlice(false));
    }
  };
};

export const getPromptoverrideByIdAction = (
  prompt_override_id,
  setEditPromptModalOpen,
  selectedOrganizationUUID
) => {
  return async (dispatch) => {
    dispatch(superAdminLoadingSlice(true));
    try {
      const { url } = getOverridesByIdConfig(prompt_override_id);
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': `${selectedOrganizationUUID}`,
        'Headless-Mode': true,
      };
      const result = await Axios.get(url, { headers });
      const response = result?.data;
      if (result?.status === 200 && response) {
        dispatch(superAdminLoadingSlice(false));
        setEditPromptModalOpen(true);
        dispatch(getPromptOverridesByIdSlice(response));
        setEditPromptModalOpen && setEditPromptModalOpen(true);
      }
    } catch (e) {
      dispatch(superAdminLoadingSlice(false));
      showToastError('Error occurred');
    }
  };
};

export const deletePromptOverridesAction = (
  prompt_override_id,
  setIsOpen,
  selectedOrganizationUUID,
  selectedCondition
) => {
  return async (dispatch) => {
    dispatch(superAdminLoadingSlice(true));
    try {
      const { url } = deletePromptOverridesConfig(prompt_override_id);
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await Axios.delete(url, { headers });
      if (result?.status === 200) {
        showToastSuccess('Prompt overrides deleted successfully');
        dispatch(superAdminLoadingSlice(false));
        setIsOpen(false);
        dispatch(
          getFilterPromptOverride(selectedOrganizationUUID, selectedCondition)
        );
      }
    } catch (e) {
      showToastError('Error occurred');
      dispatch(superAdminLoadingSlice(false));
    }
  };
};

export const getAllConditionsOverrideAction = (
  selectedOrganizationUUID,
  payload
) => {
  return async (dispatch) => {
    try {
      const { url } = getAllConditionsOverrideConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': ` ${selectedOrganizationUUID}`,
        'Headless-Mode': true,
      };
      const result = await Axios.post(url, payload, { headers });
      const response = result?.data?.missing_conditions;
      if (result?.status === 200 && response) {
        dispatch(getAllConditionsOverrideSlice(response));
      }
    } catch (e) {
      console.log(e);
    }
  };
};

export const getAllPromptScreenOverrideAction = (
  selectedOrganizationUUID,
  payload
) => {
  return async (dispatch) => {
    try {
      const { url } = getAllPromptScreenOverrideConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': ` ${selectedOrganizationUUID}`,
        'Headless-Mode': true,
      };
      const result = await Axios.post(url, payload, { headers });
      const response = result?.data;
      if (result?.status === 200 && response) {
        dispatch(getAllPromptScreenOverrideSlice(response));
      }
    } catch (e) {
      console.log(e);
    }
  };
};

export const editPromptOverrideAction = (
  prompt_override_id,
  payload,
  setIsOpen,
  setIsOrganizationSelected,
  selectedOrganizationUUID,
  setSegmentedButtons,
  selectedCondition,
  setRemovedIndices,
  setUpdatedStaticPromptPayload
) => {
  return async (dispatch) => {
    dispatch(superAdminLoadingSlice(true));
    try {
      const { url } = editOverridesConfig(prompt_override_id);
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': `${selectedOrganizationUUID}`,
        'Headless-Mode': true,
      };
      const result = await Axios.put(url, payload, { headers });
      if (result?.status === 200) {
        showToastSuccess('Prompt overrides edited successfully');
        setIsOpen(false);
        dispatch(
          getFilterPromptOverride(selectedOrganizationUUID, selectedCondition)
        );
        setIsOrganizationSelected(false);
        setSegmentedButtons([]);
        setRemovedIndices && setRemovedIndices([]);
        setUpdatedStaticPromptPayload && setUpdatedStaticPromptPayload([]);
      }
    } catch (e) {
      showToastError('Error occurred');
      dispatch(superAdminLoadingSlice(false));
    }
  };
};

export const getFilterPromptOverride = (org_uuid, condition_id) => {
  return async (dispatch) => {
    dispatch(superAdminLoadingSlice(true));
    try {
      const { url } = getFilterPromptOverrideConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': `${org_uuid}`,
        'Headless-Mode': true,
      };
      const body = {
        org_uuid: org_uuid,
        condition_id: condition_id,
      };
      const result = await Axios.post(url, body, { headers });
      const response = result?.data;
      if (result?.status === 200 && response) {
        dispatch(getAllOverridesListSlice(response));
        dispatch(superAdminLoadingSlice(false));
        org_uuid &&
          !condition_id &&
          dispatch(getAllOverridesListSlice(response));
      }
    } catch (e) {
      dispatch(superAdminLoadingSlice(false));
      showToastError('No data available');
    }
  };
};
